(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-filter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cf-filters')) {
    customElements.define('cf-filters', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.auto = this.dataset.auto === 'true';
        this.form = this.querySelector('.cf__form');

        // Gruppen auf-/zuklappen (bei accordion/bar/drawer)
        this.querySelectorAll('.cf__grouptitle').forEach(function (t) {
          t.addEventListener('click', function () {
            var grp = t.closest('.cf__group');
            if (grp) grp.classList.toggle('is-open');
          });
        });

        // Drawer öffnen/schließen
        this.querySelectorAll('[data-cf-open]').forEach(function (b) { b.addEventListener('click', function () { self.classList.add('is-open'); }); });
        this.querySelectorAll('[data-cf-close]').forEach(function (b) { b.addEventListener('click', function () { self.classList.remove('is-open'); }); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.classList.remove('is-open'); });

        // Checkboxen
        this.querySelectorAll('.cf__value input[type=checkbox]').forEach(function (cb) {
          cb.addEventListener('change', function () {
            var lab = cb.closest('.cf__value'); if (lab) lab.classList.toggle('is-active', cb.checked);
            if (self.auto) self.submit();
          });
        });

        // Preis-Slider
        this.querySelectorAll('.cf__price').forEach(function (p) { self.initPrice(p); });
      }

      submit() { if (this.form) this.form.requestSubmit ? this.form.requestSubmit() : this.form.submit(); }

      initPrice(p) {
        var self = this;
        var min = p.querySelector('.cf__r--min');
        var max = p.querySelector('.cf__r--max');
        var fill = p.querySelector('.cf__price-fill');
        var lo = p.querySelector('.cf__price-lo');
        var hi = p.querySelector('.cf__price-hi');
        var rmax = parseFloat(p.dataset.rmax) || 100;
        function paint() {
          var a = Math.min(+min.value, +max.value);
          var b = Math.max(+min.value, +max.value);
          fill.style.left = (a / rmax * 100) + '%';
          fill.style.width = ((b - a) / rmax * 100) + '%';
          lo.textContent = a; hi.textContent = b;
        }
        function clamp(e) {
          if (+min.value > +max.value) {
            if (e.target === min) min.value = max.value; else max.value = min.value;
          }
          paint();
        }
        min.addEventListener('input', clamp);
        max.addEventListener('input', clamp);
        if (this.auto) {
          min.addEventListener('change', function () { self.submit(); });
          max.addEventListener('change', function () { self.submit(); });
        }
        paint();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-food-pairing"] && !Shopify.designMode) return;
  try {
    
  if (!window.__fpBundleInit) {
    window.__fpBundleInit = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fp-add]');
      if (!btn) return;
      e.preventDefault();
      var ids = (btn.dataset.fpAdd || '').split(',').filter(Boolean);
      if (!ids.length) return;
      var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
      btn.disabled = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        var n = document.querySelector('cart-notification, cart-drawer');
        if (n && typeof n.open === 'function') { n.open(); }
        btn.classList.add('is-success');
        var t = btn.textContent; btn.textContent = '✓ Hinzugefügt';
        setTimeout(function () { btn.classList.remove('is-success'); btn.textContent = t; btn.disabled = false; }, 1600);
      }).catch(function () { btn.disabled = false; alert('Konnte nicht hinzugefügt werden.'); });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chb-carousel')) {
    customElements.define('chb-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.chb__slide'));
        this.dots = Array.from(this.querySelectorAll('.chb__dot'));
        this.index = 0;
        this.interval = (parseFloat(this.dataset.interval) || 0) * 1000;
        var prev = this.querySelector('.chb__nav--prev');
        var next = this.querySelector('.chb__nav--next');
        var self = this;
        if (prev) prev.addEventListener('click', function () { self.go(self.index - 1, true); });
        if (next) next.addEventListener('click', function () { self.go(self.index + 1, true); });
        this.dots.forEach(function (dot, i) { dot.addEventListener('click', function () { self.go(i, true); }); });
        if (this.slides.length > 1 && this.interval > 0) {
          this.start();
          this.addEventListener('mouseenter', function () { self.stop(); });
          this.addEventListener('mouseleave', function () { self.start(); });
        }
      }
      go(i, manual) {
        var n = this.slides.length;
        if (n <= 1) return;
        this.slides[this.index].classList.remove('is-active');
        if (this.dots[this.index]) this.dots[this.index].classList.remove('is-active');
        this.index = ((i % n) + n) % n;
        this.slides[this.index].classList.add('is-active');
        if (this.dots[this.index]) this.dots[this.index].classList.add('is-active');
        if (manual) this.start();
      }
      start() { var self = this; this.stop(); if (this.interval > 0 && this.slides.length > 1) this.timer = setInterval(function () { self.go(self.index + 1); }, this.interval); }
      stop() { if (this.timer) clearInterval(this.timer); }
      disconnectedCallback() { this.stop(); }
    });
  }

  if (!customElements.get('chb-mosaic')) {
    customElements.define('chb-mosaic', class extends HTMLElement {
      connectedCallback() {
        var sec = parseFloat(this.dataset.mobileAutoplay) || 0;
        if (sec <= 0) return;
        var self = this;
        this.mq = window.matchMedia('(max-width: 749px)');
        this.tick = function () {
          if (!self.mq.matches) return;
          var w = self.clientWidth;
          if (self.scrollLeft + w >= self.scrollWidth - 5) { self.scrollTo({ left: 0, behavior: 'smooth' }); }
          else { self.scrollBy({ left: w, behavior: 'smooth' }); }
        };
        this.startAuto = function () { self.stopAuto(); self.timer = setInterval(self.tick, sec * 1000); };
        this.stopAuto = function () { if (self.timer) { clearInterval(self.timer); self.timer = null; } };
        ['pointerdown', 'mouseenter'].forEach(function (e) { self.addEventListener(e, function () { self.stopAuto(); }); });
        ['pointerup', 'mouseleave'].forEach(function (e) { self.addEventListener(e, function () { self.startAuto(); }); });
        this.startAuto();
      }
      disconnectedCallback() { if (this.stopAuto) this.stopAuto(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-info-spalten"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__pjsAllergenHL) return;
  window.__pjsAllergenHL = true;

  function buildPattern(terms) {
    var parts = [];
    terms.forEach(function (raw) {
      var t = (raw || '').trim();
      if (!t) return;
      var p = '';
      for (var i = 0; i < t.length; i++) {
        var c = t[i], lc = c.toLowerCase();
        if (lc === 'ä') p += '[äa]';
        else if (lc === 'ö') p += '[öo]';
        else if (lc === 'ü') p += '[üu]';
        else if (lc === 'ß') p += '(?:ß|ss)';
        else p += c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }
      if (p) parts.push(p);
    });
    if (!parts.length) return null;
    parts.sort(function (a, b) { return b.length - a.length; });
    return new RegExp('(^|[^A-Za-zÄÖÜäöüß])(' + parts.join('|') + ')', 'gi');
  }

  function highlight(el, re) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) {
      if (n.parentNode && n.parentNode.tagName !== 'STRONG') nodes.push(n);
    }
    nodes.forEach(function (node) {
      var txt = node.nodeValue;
      re.lastIndex = 0;
      if (!re.test(txt)) return;
      re.lastIndex = 0;
      var frag = document.createDocumentFragment(), last = 0, m;
      while ((m = re.exec(txt))) {
        var ts = m.index + (m[1] ? m[1].length : 0);
        if (ts > last) frag.appendChild(document.createTextNode(txt.slice(last, ts)));
        var s = document.createElement('strong');
        s.className = 'nw__al';
        s.textContent = m[2].toUpperCase();
        frag.appendChild(s);
        last = ts + m[2].length;
        if (m[0].length === 0) re.lastIndex++;
      }
      if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function run() {
    document.querySelectorAll('[data-nw-zutaten]').forEach(function (el) {
      if (el.dataset.nwDone) return;
      var re = buildPattern((el.getAttribute('data-allergens') || '').split(','));
      if (!re) { el.dataset.nwDone = '1'; return; }
      try { highlight(el, re); } catch (e) {}
      el.dataset.nwDone = '1';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-naehrwerte"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__pjsAllergenHL) return;
  window.__pjsAllergenHL = true;

  function buildPattern(terms) {
    var parts = [];
    terms.forEach(function (raw) {
      var t = (raw || '').trim();
      if (!t) return;
      var p = '';
      for (var i = 0; i < t.length; i++) {
        var c = t[i], lc = c.toLowerCase();
        if (lc === 'ä') p += '[äa]';
        else if (lc === 'ö') p += '[öo]';
        else if (lc === 'ü') p += '[üu]';
        else if (lc === 'ß') p += '(?:ß|ss)';
        else p += c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }
      if (p) parts.push(p);
    });
    if (!parts.length) return null;
    parts.sort(function (a, b) { return b.length - a.length; });
    return new RegExp('(^|[^A-Za-zÄÖÜäöüß])(' + parts.join('|') + ')', 'gi');
  }

  function highlight(el, re) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) {
      if (n.parentNode && n.parentNode.tagName !== 'STRONG') nodes.push(n);
    }
    nodes.forEach(function (node) {
      var txt = node.nodeValue;
      re.lastIndex = 0;
      if (!re.test(txt)) return;
      re.lastIndex = 0;
      var frag = document.createDocumentFragment(), last = 0, m;
      while ((m = re.exec(txt))) {
        var ts = m.index + (m[1] ? m[1].length : 0);
        if (ts > last) frag.appendChild(document.createTextNode(txt.slice(last, ts)));
        var st = document.createElement('strong');
        st.className = 'nw__al';
        st.textContent = m[2].toUpperCase();
        frag.appendChild(st);
        last = ts + m[2].length;
        if (m[0].length === 0) re.lastIndex++;
      }
      if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function run() {
    document.querySelectorAll('[data-nw-zutaten]').forEach(function (el) {
      if (el.dataset.nwDone) return;
      var re = buildPattern((el.getAttribute('data-allergens') || '').split(','));
      if (!re) { el.dataset.nwDone = '1'; return; }
      try { highlight(el, re); } catch (e) {}
      el.dataset.nwDone = '1';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-produkt-hotspots"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setActiveMarker(root, id) {
      root.querySelectorAll('.hs__marker.is-active, .hs__mcard.is-active').forEach(function (m) { m.classList.remove('is-active'); });
      root.querySelectorAll('[data-hs-open="' + id + '"]').forEach(function (m) { m.classList.add('is-active'); });
    }
    function closeRoot(root) {
      if (!root || root.classList.contains('hs--alwayson')) return;
      root.querySelectorAll('.hs__panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
      root.querySelectorAll('.hs__marker.is-active, .hs__mcard.is-active').forEach(function (m) { m.classList.remove('is-active'); });
      root.classList.remove('hs--open');
    }
    function openPanel(root, id) {
      var panel = document.getElementById(id);
      if (!panel || !root) return;
      root.querySelectorAll('.hs__panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
      panel.classList.add('is-open');
      root.classList.add('hs--open');
      setActiveMarker(root, id);
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-hs-open]');
      if (opener) {
        e.preventDefault();
        var root = opener.closest('[data-hs-root]');
        var id = opener.getAttribute('data-hs-open');
        var target = document.getElementById(id);
        var alwaysOn = root && root.classList.contains('hs--alwayson');
        if (target && target.classList.contains('is-open') && !alwaysOn) { closeRoot(root); return; }
        openPanel(root, id);
        return;
      }
      var navBtn = e.target.closest('[data-hs-nav]');
      if (navBtn) {
        var nroot = navBtn.closest('[data-hs-root]');
        if (!nroot) return;
        var panels = Array.prototype.slice.call(nroot.querySelectorAll('.hs__panel'));
        var current = nroot.querySelector('.hs__panel.is-open');
        var idx = panels.indexOf(current);
        if (idx < 0) return;
        var dir = navBtn.getAttribute('data-hs-nav') === 'next' ? 1 : -1;
        var next = panels[(idx + dir + panels.length) % panels.length];
        openPanel(nroot, next.id);
        return;
      }
      var closer = e.target.closest('[data-hs-close]');
      if (closer) { closeRoot(closer.closest('[data-hs-root]')); return; }
      var addBtn = e.target.closest('[data-bundle-add]');
      if (addBtn) { var hsRoot = addBtn.closest('[data-hs-root]'); if (hsRoot) closeRoot(hsRoot); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { document.querySelectorAll('[data-hs-root].hs--open').forEach(closeRoot); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-produkt-teaser"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!customElements.get('pt-slider')) {
    class PTSlider extends HTMLElement {
      connectedCallback(){
        this.track = this.querySelector('[data-pt-track]');
        if(!this.track) return;
        this.prev = this.querySelector('[data-pt-prev]');
        this.next = this.querySelector('[data-pt-next]');
        this.prev && this.prev.addEventListener('click', () => this.track.scrollBy({left:-this.step(), behavior:'smooth'}));
        this.next && this.next.addEventListener('click', () => this.track.scrollBy({left:this.step(), behavior:'smooth'}));
        this.track.addEventListener('scroll', () => this.updateNav(), {passive:true});
        window.addEventListener('resize', () => this.updateNav());
        this.initDrag();
        this.initAutoplay();
        this.updateNav();
      }
      step(){
        var t = this.track.querySelector('.pt__tile');
        var g = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
        return t ? (t.offsetWidth + g) : this.track.clientWidth * 0.8;
      }
      updateNav(){
        var t = this.track, max = t.scrollWidth - t.clientWidth - 2;
        if (this.prev) this.prev.toggleAttribute('disabled', t.scrollLeft <= 2);
        if (this.next) this.next.toggleAttribute('disabled', t.scrollLeft >= max);
      }
      initDrag(){
        var t = this.track, down=false, sx=0, sl=0, moved=false;
        t.addEventListener('pointerdown', function(e){ if(e.pointerType!=='mouse') return; down=true; moved=false; sx=e.clientX; sl=t.scrollLeft; t.classList.add('is-grabbing'); });
        window.addEventListener('pointermove', function(e){ if(!down) return; var dx=e.clientX-sx; if(Math.abs(dx)>4) moved=true; t.scrollLeft = sl - dx; });
        window.addEventListener('pointerup', function(){ down=false; t.classList.remove('is-grabbing'); });
        t.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } }, true);
      }
      initAutoplay(){
        var sec = parseFloat(this.dataset.autoplay || '0'); if(!sec) return;
        var self = this, timer = null;
        var go = function(){ var t=self.track, max=t.scrollWidth-t.clientWidth-2; if(t.scrollLeft>=max){ t.scrollTo({left:0,behavior:'smooth'}); } else { t.scrollBy({left:self.step(),behavior:'smooth'}); } };
        var start = function(){ stop(); timer = setInterval(go, sec*1000); };
        var stop = function(){ if(timer) clearInterval(timer); timer=null; };
        start();
        this.addEventListener('pointerenter', stop);
        this.addEventListener('pointerleave', start);
        this.addEventListener('focusin', stop);
        this.addEventListener('focusout', start);
      }
    }
    customElements.define('pt-slider', PTSlider);
  }

  if (!window.__ptCartBound) {
    window.__ptCartBound = true;
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-pt-add]'); if(!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-pt-add'); if(!id) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      btn.classList.add('is-loading'); btn.disabled = true;
      fetch(root + 'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items:[{ id:Number(id), quantity:1 }] })
      }).then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description || j.message || 'Fehler'); }); return r.json(); })
        .then(function(){
          document.dispatchEvent(new CustomEvent('cart:updated', {bubbles:true}));
          var n = document.querySelector('cart-notification, cart-drawer');
          if (n && typeof n.open === 'function') n.open();
          btn.classList.remove('is-loading'); btn.classList.add('is-success');
          setTimeout(function(){ btn.classList.remove('is-success'); btn.disabled=false; }, 1400);
        }).catch(function(err){ btn.classList.remove('is-loading'); btn.disabled=false; alert('Warenkorb: ' + err.message); });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tab-galerie"] && !Shopify.designMode) return;
  try {
    
  if (!window.__tgTabsInit) {
    window.__tgTabsInit = true;
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tg-tab]');
      if (!tab) return;
      var root = tab.closest('.tg');
      if (!root) return;
      var key = tab.dataset.tgTab;
      root.querySelectorAll('[data-tg-tab]').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      root.querySelectorAll('[data-tg-panel]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.tgPanel === key); });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tasting-buchung"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (customElements.get('tb-book')) return;
  function eur(c){ return '€' + (c/100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  customElements.define('tb-book', class extends HTMLElement {
    connectedCallback(){
      this.persons = 1;
      this.unit = parseInt(this.dataset.unit,10)||0;
      this.max = parseInt(this.dataset.max,10)||18;
      var self=this;
      this.querySelectorAll('[data-tb-inc]').forEach(function(b){ b.addEventListener('click',function(){ self.step(1); }); });
      this.querySelectorAll('[data-tb-dec]').forEach(function(b){ b.addEventListener('click',function(){ self.step(-1); }); });
      this.querySelectorAll('[data-tb-reserve]').forEach(function(b){ b.addEventListener('click',function(e){ self.reserve(e,b); }); });
    }
    step(d){
      this.persons = Math.min(this.max, Math.max(1, this.persons+d));
      var s=this;
      this.querySelectorAll('[data-tb-persons]').forEach(function(el){ el.textContent=s.persons; });
      this.querySelectorAll('[data-tb-personword]').forEach(function(el){ el.textContent = s.persons===1 ? (s.dataset.word1||'Person') : (s.dataset.wordn||'Personen'); });
      if(this.unit){ var t=this.querySelector('[data-tb-total]'); if(t) t.textContent=eur(this.unit*this.persons); }
    }
    reserve(e,btn){
      if(!this.dataset.variant) return;
      e.preventDefault();
      var self=this, root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
      btn.classList.add('is-loading');
      fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(this.dataset.variant),quantity:this.persons}]})})
        .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||'Fehler'); }); return r.json(); })
        .then(function(){ document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true})); var n=document.querySelector('cart-notification, cart-drawer'); if(n&&n.open) n.open(); btn.classList.remove('is-loading'); btn.classList.add('is-success'); setTimeout(function(){ btn.classList.remove('is-success'); },1500); })
        .catch(function(err){ btn.classList.remove('is-loading'); alert('Warenkorb: '+err.message); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tasting-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (customElements.get('tct-cta')) return;
  customElements.define('tct-cta', class extends HTMLElement {
    connectedCallback(){
      var self=this;
      this.querySelectorAll('[data-tct-reserve]').forEach(function(b){ b.addEventListener('click', function(e){ self.reserve(e,b); }); });
    }
    reserve(e,btn){
      if(!this.dataset.variant) return;
      e.preventDefault();
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
      btn.classList.add('is-loading');
      fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(this.dataset.variant),quantity:1}]})})
        .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||'Fehler'); }); return r.json(); })
        .then(function(){ document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true})); var n=document.querySelector('cart-notification, cart-drawer'); if(n&&n.open) n.open(); btn.classList.remove('is-loading'); btn.classList.add('is-success'); setTimeout(function(){ btn.classList.remove('is-success'); },1500); })
        .catch(function(err){ btn.classList.remove('is-loading'); alert('Warenkorb: '+err.message); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tasting-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (customElements.get('tfq-acc')) return;
  customElements.define('tfq-acc', class extends HTMLElement {
    connectedCallback(){
      var single = this.dataset.single === '1';
      var group = this.querySelector('[data-tfq]'); if(!group) return;
      group.addEventListener('click', function(e){
        var tog = e.target.closest('[data-tfq-toggle]'); if(!tog) return;
        var item = tog.closest('[data-tfq-item]');
        var open = item.classList.contains('is-open');
        if(single){ group.querySelectorAll('[data-tfq-item]').forEach(function(it){ it.classList.remove('is-open'); var s=it.querySelector('.tfq__sign'); if(s) s.textContent='+'; }); }
        if(open && !single){ item.classList.remove('is-open'); var s=item.querySelector('.tfq__sign'); if(s) s.textContent='+'; }
        else if(!open){ item.classList.add('is-open'); var s2=item.querySelector('.tfq__sign'); if(s2) s2.textContent='–'; }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tasting-seite"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (customElements.get('ts-page')) return;
  function eur(cents){
    var v = (cents/100).toFixed(2).replace('.', ',');
    return '€' + v.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  customElements.define('ts-page', class extends HTMLElement {
    connectedCallback(){
      // counter
      this.persons = 1;
      this.unit = parseInt(this.dataset.unit, 10) || 0;
      this.max = parseInt(this.dataset.max, 10) || 18;
      var self = this;
      this.querySelectorAll('[data-ts-inc]').forEach(function(b){ b.addEventListener('click', function(){ self.step(1); }); });
      this.querySelectorAll('[data-ts-dec]').forEach(function(b){ b.addEventListener('click', function(){ self.step(-1); }); });
      // faq (accordion, eine offen)
      this.querySelectorAll('[data-ts-faq]').forEach(function(group){
        group.addEventListener('click', function(e){
          var tog = e.target.closest('[data-ts-faq-toggle]'); if(!tog) return;
          var item = tog.closest('[data-ts-faq-item]');
          var open = item.classList.contains('is-open');
          group.querySelectorAll('[data-ts-faq-item]').forEach(function(it){ it.classList.remove('is-open'); var s=it.querySelector('.ts__faq-sign'); if(s) s.textContent='+'; });
          if(!open){ item.classList.add('is-open'); var s=item.querySelector('.ts__faq-sign'); if(s) s.textContent='–'; }
        });
      });
      // reserve
      this.querySelectorAll('[data-ts-reserve]').forEach(function(btn){
        btn.addEventListener('click', function(e){ self.reserve(e, btn); });
      });
    }
    step(dir){
      this.persons = Math.min(this.max, Math.max(1, this.persons + dir));
      var self = this;
      this.querySelectorAll('[data-ts-persons]').forEach(function(el){ el.textContent = self.persons; });
      this.querySelectorAll('[data-ts-personword]').forEach(function(el){ el.textContent = self.persons === 1 ? (self.dataset.word1||'Person') : (self.dataset.wordn||'Personen'); });
      if(this.unit){ var t=this.querySelector('[data-ts-total]'); if(t) t.textContent = eur(this.unit * this.persons); }
    }
    reserve(e, btn){
      if(!this.dataset.variant){ return; } // kein Produkt → folge href
      e.preventDefault();
      var self = this, id = this.dataset.variant;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      btn.classList.add('is-loading');
      fetch(root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items:[{ id:Number(id), quantity:self.persons }] }) })
        .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||j.message||'Fehler'); }); return r.json(); })
        .then(function(){
          document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
          var n = document.querySelector('cart-notification, cart-drawer'); if(n && typeof n.open==='function') n.open();
          btn.classList.remove('is-loading'); btn.classList.add('is-success');
          setTimeout(function(){ btn.classList.remove('is-success'); }, 1500);
        }).catch(function(err){ btn.classList.remove('is-loading'); alert('Warenkorb: '+err.message); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tasting-uebersicht"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (customElements.get('tg-grid')) return;
  customElements.define('tg-grid', class extends HTMLElement {
    connectedCallback(){
      this.grid = this.querySelector('[data-tg-grid]');
      if(!this.grid) return;
      this.cards = Array.from(this.grid.querySelectorAll('.tg__card'));
      this.chips = this.querySelector('[data-tg-chips]');
      this.countEl = this.querySelector('[data-tg-count]');
      this.emptyEl = this.querySelector('[data-tg-empty]');

      if (this.dataset.sort === '1'){
        var ordered = this.cards.slice().sort(function(a,b){
          var ta = parseInt(a.dataset.ts,10); var tb = parseInt(b.dataset.ts,10);
          if(isNaN(ta)) ta = Infinity; if(isNaN(tb)) tb = Infinity;
          return ta - tb;
        });
        ordered.forEach(function(c){ this.grid.appendChild(c); }, this);
        this.cards = ordered;
      }

      if (this.chips){
        var self = this;
        this.chips.addEventListener('click', function(e){
          var chip = e.target.closest('[data-cat]'); if(!chip) return;
          self.chips.querySelectorAll('.tg__chip').forEach(function(c){ c.classList.toggle('is-active', c === chip); });
          self.filter(chip.dataset.cat);
        });
      }
    }
    filter(cat){
      var n = 0;
      this.cards.forEach(function(card){
        var cats = card.dataset.cats || '';
        var show = cat === '__all' || cats.indexOf(' ' + cat + ' ') > -1;
        card.style.display = show ? '' : 'none';
        if(show) n++;
      });
      if(this.countEl) this.countEl.textContent = n;
      if(this.emptyEl) this.emptyEl.hidden = n > 0;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-wein-der-woche"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__wdwCartBound) return;
  window.__wdwCartBound = true;
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-wdw-add]'); if(!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-wdw-add'); if(!id) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    b.classList.add('is-loading'); b.disabled = true;
    fetch(root + 'cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id:Number(id), quantity:1 }] })
    }).then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description || j.message || 'Fehler'); }); return r.json(); })
      .then(function(){
        document.dispatchEvent(new CustomEvent('cart:updated', {bubbles:true}));
        var n = document.querySelector('cart-notification, cart-drawer');
        if (n && typeof n.open === 'function') n.open();
        b.classList.remove('is-loading'); b.classList.add('is-success');
        setTimeout(function(){ b.classList.remove('is-success'); b.disabled=false; }, 1400);
      }).catch(function(err){ b.classList.remove('is-loading'); b.disabled=false; alert('Warenkorb: ' + err.message); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-weinkatalog-magazin"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__wkCartBound) return;
  window.__wkCartBound = true;
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-wk-add]'); if(!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-wk-add'); var qty = parseInt(b.getAttribute('data-wk-qty'),10) || 1;
    if(!id) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    b.classList.add('is-loading');
    fetch(root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id:Number(id), quantity:qty }] }) })
      .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||j.message||'Fehler'); }); return r.json(); })
      .then(function(){
        document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
        var n = document.querySelector('cart-notification, cart-drawer'); if(n && typeof n.open==='function') n.open();
        b.classList.remove('is-loading'); b.classList.add('is-success');
        setTimeout(function(){ b.classList.remove('is-success'); }, 1300);
      }).catch(function(err){ b.classList.remove('is-loading'); alert('Warenkorb: '+err.message); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-weinkatalog"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__wkCartBound) return;
  window.__wkCartBound = true;
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-wk-add]'); if(!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-wk-add'); var qty = parseInt(b.getAttribute('data-wk-qty'),10) || 1;
    if(!id) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    b.classList.add('is-loading');
    fetch(root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id:Number(id), quantity:qty }] }) })
      .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||j.message||'Fehler'); }); return r.json(); })
      .then(function(){
        document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
        var n = document.querySelector('cart-notification, cart-drawer'); if(n && typeof n.open==='function') n.open();
        b.classList.remove('is-loading'); b.classList.add('is-success');
        setTimeout(function(){ b.classList.remove('is-success'); }, 1300);
      }).catch(function(err){ b.classList.remove('is-loading'); alert('Warenkorb: '+err.message); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
